const tkParse = require('@moke/vue-tk').tkParse
/**
 * 判断是否点赞或收藏此帖子
 * @date: 2020/3/26
 */
async function judgePosts (className, obj) {
  let res = await tkParse.getList(`/classes/${className}`, {
    params: {
      limit: 1,
      where: obj
    }
  })
  return !!res.length
}
export {
  judgePosts
}
